<app-mu-section-title icon="fa fa-fw fa-list-ul"></app-mu-section-title>
<app-massive-services-table
  id="ctx-masivos-service-table"
  [flags]="flags"
  [tableListColumns]="servicesTableColumns"
  [dataList]="servicesDataList"
  [filters]="servicesFilters"
  [tableOptionList]="tableOptionList"
  [actions]="servicesActions"
  (rowActionEvent)="selectMapMarker($event)"
>
</app-massive-services-table>
<app-mu-loading-modal-dialog [processingData]="processingRoute"></app-mu-loading-modal-dialog>
